import { FlexCol } from "../../../components/Container/Container";
import Text from "../../../components/Text/Text";

export const DoubleRowTitle = ({
  top,
  bottom,
  topSize,
  bottomSize,
}: {
  top: string;
  bottom: string;
  topSize?: any; //12 | 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 32 | 34 | 36 | 38 | 40 | 46 | 50;
  bottomSize?: any; //12 | 14 | 16 | 18 | 20 | 22 | 24 | 26 | 28 | 30 | 32 | 34 | 36 | 38 | 40 | 46 | 50;
}) => {
  return (
    <FlexCol>
      <Text level={5} fontSize={topSize} fontWeight={700}>
        {top}
      </Text>
      <Text level={6} fontSize={bottomSize} fontWeight={700}>
        {bottom}
      </Text>
    </FlexCol>
  );
};
